module.exports = __webpack_public_path__ + "img/diploma_1.259377bc.jpg";